// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_property_propertyLocation(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["PropertyLocationWithVisibleAddress"]);
}

let fragmentConverter = {"__root":{"property_propertyLocation":{"u":"fragment_property_propertyLocation"}}};

let fragmentConverterMap = {
  fragment_property_propertyLocation: unwrap_fragment_property_propertyLocation
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function forSalePropertyMatchingType_decode($$enum) {
  if ($$enum === "BROADCAST" || $$enum === "QUIET_ANONYMOUS" || $$enum === "ONE_WAY" || $$enum === "QUIET") {
    return $$enum;
  }
}

let forSalePropertyMatchingType_fromString = forSalePropertyMatchingType_decode;

function visibilityReason_decode($$enum) {
  if ($$enum === "VISIBLE_TO_ACCOUNT_MEMBER" || $$enum === "VISIBLE_TO_TAN_STAFF" || $$enum === "VISIBLE_TO_ALL") {
    return $$enum;
  }
}

let visibilityReason_fromString = visibilityReason_decode;

let Utils = {
  forSalePropertyMatchingType_decode: forSalePropertyMatchingType_decode,
  forSalePropertyMatchingType_fromString: forSalePropertyMatchingType_fromString,
  visibilityReason_decode: visibilityReason_decode,
  visibilityReason_fromString: visibilityReason_fromString
};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MyClientsWidgetSeller_name_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "ForSalePropertyV5",
        "kind": "LinkedField",
        "name": "property",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": "forSalePropertyMatchingType",
              "args": null,
              "kind": "ScalarField",
              "name": "matchingType",
              "storageKey": null
            },
            "action": "THROW"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "propertyLocation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "visibilityRule",
                    "storageKey": null
                  }
                ],
                "type": "PropertyLocationWithVisibleAddress",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

let wrap_fragment_property_propertyLocation = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_property_propertyLocation = unwrap_fragment_property_propertyLocation;
exports.wrap_fragment_property_propertyLocation = wrap_fragment_property_propertyLocation;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
